var cell_default = {
  "cell": "-RblX",
  "header": "_3HKUP",
  "selected": "XXZAD",
  "editing": "WckkI",
  "singleSelection": "TsCLV",
  "hideLastBlock": "_30zvJ",
  "editorWrapper": "_8bIRn",
  "viewerWrapper": "ETt3Y",
  "hideFirstBlock": "oZKnR",
  "editor": "mfXO6",
  "edit": "_3QY-T",
  "view": "_8YjNg",
  "editingToolbarWrapper": "iCTz8",
  "selectAll": "RPIXq",
  "disableSelection": "El3OT"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
